export default __webpack_public_path__ + "static/img/pattern-cow.27a8448.png";